module.exports = require.ensure([
  'google-libphonenumber',
  'countries-list',
  'vue',
  './input-phone.amd.vue'
], function () {
  return require('./input-phone.amd.vue');
});



// WEBPACK FOOTER //
// ./app/components/molecules/input-phone/input-phone.amd.js